import { ID, IDPrefixes, newTaskSuffix } from '@griply/types';

import { hasCompositeIdPrefix } from '../encoded-ids/composite-id';

// Section children also hold presentational rows; only task ids may be persisted.
export const filterReorderableChildIds = (children: ID[] | undefined): ID[] =>
  children
    ? children.filter(
        (id) =>
          !id.endsWith(newTaskSuffix) &&
          !hasCompositeIdPrefix(id, IDPrefixes.GoalDeadline),
      )
    : [];
